export function subscriptionApiBaseUrl(): string {
  const u = import.meta.env.VITE_XQ_API_BASE_URL as string | undefined;
  return typeof u === "string" ? u.replace(/\/+$/g, "") : "";
}
